/**
 * Testimonials (new) section – Splide carousel + custom drag cursor.
 * Expects section root to have data-section-id (Liquid section.id).
 * Run after Splide and splide-extension-auto-scroll are loaded (defer is sufficient).
 */
(function () {
  'use strict';

  function initDragCursor(sectionId) {
    var wrap = document.getElementById('testimonials-drag-wrap-' + sectionId);
    var cursor = document.getElementById('testimonials-drag-cursor-' + sectionId);
    if (!wrap || !cursor) return;

    if (window.innerWidth <= 991) {
      cursor.style.display = 'none';
      return;
    }

    var lastX = 0;
    var lastY = 0;

    function moveCursor(e) {
      lastX = e.clientX;
      lastY = e.clientY;
      cursor.style.transform = 'translate3d(' + lastX + 'px, ' + lastY + 'px, 0) translate(-50%, -50%)';
    }

    function showCursor() {
      cursor.style.transform = 'translate3d(' + lastX + 'px, ' + lastY + 'px, 0) translate(-50%, -50%)';
      cursor.style.opacity = '1';
      cursor.classList.add('is-visible');
    }

    function hideCursor() {
      cursor.style.opacity = '0';
      cursor.classList.remove('is-visible');
    }

    wrap.addEventListener('mouseenter', showCursor);
    wrap.addEventListener('mouseleave', hideCursor);
    wrap.addEventListener('mousemove', moveCursor);

    window.addEventListener('resize', function () {
      if (window.innerWidth <= 991) {
        cursor.style.display = 'none';
        hideCursor();
      } else {
        cursor.style.display = '';
      }
    });
  }

  function initCarousel(sectionId) {
    var carouselEl = document.getElementById('testimonial-carousel-' + sectionId);
    if (!carouselEl || typeof window.Splide === 'undefined') return;

    var gap = parseInt(carouselEl.getAttribute('data-splide-gap') || '32', 10);
    var minWidth = parseInt(carouselEl.getAttribute('data-splide-min-width') || '280', 10);
    var Extensions = window.splide && window.splide.Extensions ? window.splide.Extensions : {};

    var splideInstance = new window.Splide(carouselEl, {
      type: 'loop',
      drag: true,
      autoWidth: true,
      minWidth: minWidth + 'px',
      gap: gap + 'px',
      padding: { left: '1rem', right: '1rem' },
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: 0.8,
        autoStart: true,
        pauseOnHover: false
      },
      breakpoints: {
        991: {
          perPage: 1,
          autoWidth: false,
          fixedWidth: '85%',
          gap: '0.5rem',
          padding: { left: '1rem', right: '1rem' }
        }
      }
    });

    splideInstance.mount(Extensions);

    var prevBtn = carouselEl.querySelector('.splide__arrow--prev');
    var nextBtn = carouselEl.querySelector('.splide__arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { splideInstance.go('<'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { splideInstance.go('>'); });
  }

  function initSection(sectionEl) {
    var sectionId = sectionEl.getAttribute('data-section-id');
    if (!sectionId) return;
    initCarousel(sectionId);
    initDragCursor(sectionId);
  }

  function init() {
    var sections = document.querySelectorAll('.testimonials-new[data-section-id]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
